const $ = jQuery;

const Template = new (class {
  constructor() {
    $(() => this.onDocumentReady());
  }

  onDocumentReady() {
    this.initHeader();
    this.initToolbar();
    this.initAccordion();
    this.initContactOverlay();
  }

  initHeader() {
    // Navigation Toggle Button
    const toggleBtn = document.querySelector('.nav-main-toggle-btn');

    if (toggleBtn) {
      toggleBtn.addEventListener('click', (e) => {
        document.documentElement.classList.toggle('nav-main-open');
        e.preventDefault();
      });
    }

    let lastScr = 0;

    // Scroll Handler
    const handleScroll = () => {
      const scr = window.scrollY || window.pageYOffset;
      const body = document.body;

      body.classList.toggle('sticky', scr >= 100);
      body.classList.toggle('scrolling-up', scr < lastScr);
      body.classList.toggle('scrolling-down', scr > lastScr);

      lastScr = scr;
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
  }

  initToolbar() {
    const toggleBtn = document.querySelector('.toolbar-search-toggle-btn');
    const wrapper = document.querySelector('.toolbar-search-wrapper');

    if (toggleBtn && wrapper) {
      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        wrapper.classList.toggle('toolbar-search-open');
      });
    }
  }

  initAccordion() {
    $('.ce-accordion .accordion-headline button').click(function (e) {
      e.preventDefault();

      const elem = $(this).closest('.accordion-panel');
      elem
        .siblings('.active')
        .addBack()
        .toggleClass('active')
        .children('.accordion-content')
        .slideToggle(300, function () {
          const t = $(this),
            p = t.closest('.accordion-panel');

          if (p.is('.active')) {
            $('body, html').animate({ scrollTop: p.offset().top - ($('header').height() + 10) }, 300);
          }
        });
    });
  }

  initContactOverlay() {
    $('.toolbar-contact a, .contact-overlay-close, .contact-overlay-bgr').click(function (e) {
      $('body').toggleClass('contact-overlay-open');
      $('#contact-overlay').fadeToggle(150, 'linear');
      e.preventDefault();
    });
  }
})();

window.Template = Template;
